import * as React from 'react';

declare global {
  interface Window {
    __INIT_DATA__: any;
  }
}

interface Config {
  displayName?: string;
}

export const connectSsr = (config: Config = {}) => (WrappedComponent: any) => {
  class C extends React.Component<
    { dispatch: any; location: any },
    { d: any; loading: boolean }
  > {
    public static async getInitialProps(props) {
      if (
        WrappedComponent &&
        typeof WrappedComponent['getInitialProps'] === 'function'
      ) {
        const c = await WrappedComponent.getInitialProps(props);
        return { ...c, loading: false };
      }
      return {};
    }

    public static getID() {
      return config.displayName;
    }

    public getInitData() {
      if (
        config.displayName &&
        typeof window.__INIT_DATA__ !== 'undefined' &&
        window.__INIT_DATA__[config.displayName]
      ) {
        return window.__INIT_DATA__[config.displayName];
      }
      return null;
    }

    constructor(props) {
      super(props);
      this.state = {
        d: {},
        loading: true
      };
    }

    public async componentWillReceiveProps(nextProps) {
      if (
        nextProps.location.pathname !== this.props.location.pathname ||
        nextProps.location.query !== this.props.location.query
      ) {
        this.setState({ loading: true });
        const d = await C.getInitialProps(nextProps);
        return this.setState({ d, loading: false });
      }
    }

    public async componentDidMount() {
      const data = this.getInitData();
      if (data === null) {
        this.setState({ loading: true });
        const d = await C.getInitialProps(this.props);
        return this.setState({ d, loading: false });
      }
      return this.setState({
        d: data,
        loading: false
      });
    }

    public render() {
      let data = this.getInitData() || {};
      return <WrappedComponent {...data} {...this.state.d} {...this.props} />;
    }
  }
  return C as any;
};

export const ssrContext = React.createContext({
  register: (cb: Function) => {}
});

/**
 * Effects with Cleanup not supported
 */
export const useAsyncData = (cb: Function, deps?: ReadonlyArray<any>) => {
  React.useContext(ssrContext).register(cb);
  React.useEffect(() => {
    cb();
  }, deps);
};
